import React from 'react';
import NavigationMenuSection from "../../../menu-items/section/section";
import NavigationMenu_ProjectsLocalSettings from "../../../local-settings";
import ArrayUtils from "../../../../../core/gd/utils/array";
import {EVENT_BUS_SESSION_PORTFOLIO_CHANGED} from "../../../../../core/model2/project-collection/events";
import NavigationMenu_NewView from "../../../menu-items/menu-new-view/menu-new-view";
import ProjectSession from "../../../../../core/model2/project/project-session";
import mainMenu_workspaceViews from "../../../actions/workspace-views";
import NavigationMenuItemProject from "../../../menu-items/project/menu-item-project";
import Workspace from "../../../../../core/model2/space/workspaces/workspace";
import MainMenu_SectionReorderableWithMore from "../../../components/menu-controller/menu-section-reordable-with-more";
import {BUS_APP_LAUNCH} from "../../../../../core/gd/app-manager/@event"

type Props = {
    workspace               : Workspace,
}

export default class MainMenu_WorkspaceCustomViews extends React.Component<Props,any> {

    public localSettings    : NavigationMenu_ProjectsLocalSettings

    constructor(props:any) {
        super(props);

        this.localSettings = new NavigationMenu_ProjectsLocalSettings()
    }

    componentDidMount() {
        gd.bus.subscribe('gd.session.customViews:change', this, this.update)
        gd.bus.subscribe(EVENT_BUS_SESSION_PORTFOLIO_CHANGED, this, this.update)
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.update)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    update = () => {
        this.forceUpdate()
    }

    sessionDataChanged = () => {this.forceUpdate()}

    onReorderEnd = (items:any) => {
        gd.user.settings.menu.homeCustomViews.sortPositions = items.map((item:any)=>item.id);
        gd.user.settings.menu.save();
    };


    render() {
        const components : any[] = []

        const projectIds = mainMenu_workspaceViews(this.props.workspace.project)

        _.map(projectIds, (projectId:ID) => {
            const project: ProjectSession = gd.session.projects.get(projectId)!
            const fragment = gd.router.history.fragment || ''
            const isSelected = _.startsWith(fragment, 'p/') && fragment.includes(project.id)

            components.push({
                item:       project,
                // component:   <NavigationMenuItemProjectWithChildren projectId={projectId} />
                component:   <NavigationMenuItemProject key                     = {projectId}
                                                        colorized               = {false}
                                                        project                 = {project}
                                                        isSelected              = {isSelected}
                                                        isExpanded              = {false}
                                                        level                   = {0}
                                                        onMenuItemHandleClick   = {()=>{}}
                                                        onAddInline             = {()=>{}}
                />
            })
        })

        const menuItems = _(components)
            .orderBy([
                component=>ArrayUtils.indexOrder(gd.user.settings.menu.homeCustomViews.sortPositions, component.item.id), // try to order by sort position
            ], ['asc'])
            .value();

        return (
            <NavigationMenuSection name="Views" collapsible={true} systemName={this.props.workspace.id+"-views"} counter={components.length}>

                <MainMenu_SectionReorderableWithMore countVisibleItems   = {5}
                                                     settingsKey         = {this.props.workspace.id+"-views"}
                                                     moreTitle           = "All Views"
                                                     showAdd             = {false}
                                                     components          = {menuItems}
                                                     onReorderEnd        = {this.onReorderEnd}/>

                {/*<ReorderList items={menuItems}*/}
                {/*             keyFunction={(item:any)=>item.id}*/}
                {/*             onReorder={this.onReorderEnd} />*/}

                <NavigationMenu_NewView selectedGroupId = 'tasks'
                                        workspace       = {this.props.workspace.project}
                />

            </NavigationMenuSection>
        );
    }
}
